import * as types from "../constants/actionConstants";

export function pushCallBack(func) {
    return {
        type: types.REVIEW_TEMPLATE_CALLBACK_PUSH,
        payload: func
    };
}

export function popCallBack()  {
    return {
        type: types.REVIEW_TEMPLATE_CALLBACK_POP,
    };
}

// export function clearCallBack() {
//     return {
//         type: types.REVIEW_TEMPLATE_CALLBACK_CLEAR
//     }
// }

